module.exports = "./img/7f87be2fe5340c8782b80dd78ba492c9.jpg";